<template>
  <v-container fluid class="content-container">
    <v-layout row wrap>
      <v-flex md7 xs12 sm12>
        <div class="heading then-cardlist heading-top">Connect To Twitter</div>

        <div class="no-hero" v-if="disableTwitter">
          <div class="icon">
            <img src="/images/icons/bird.svg" alt="No Books" class="icon-img" />
          </div>
          <div class="message message-small">Twitter Features are currently disabled</div>
          <div class="sub-message">
            Due to the rapidly changing environment at Twitter,
                <br />we have disabled this feature.
                <br />
                <br />Thank you for your understanding!
          </div>
        </div>
        <div class="no-hero" v-else>
          <div class="icon">
            <img src="/images/icons/bird.svg" alt="No Books" class="icon-img" />
          </div>
          <div class="message message-small">Earn snaps by liking and retweeting other authors!</div>
          <div class="sub-message">
            Click the button below to connect Pubby
            <br />to your Twitter account.
            <br />
            <br />Pubby will only like or retweet tweets when you click to like or retweet yourself.
            <br />
            <br />You'll earn snaps
            for every like and retweet right away!
            <br />
            <br />
            <a :href="authUrl" v-if="authUrl">
              <div class="action sign-in-to-twitter">Sign in to Twitter</div>
            </a>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Back from "../../modules/Back";
import Cookies from "js-cookie";

export default {
  name: "SignInToTwitter",
  data: function() {
    return {
      authUrl: null
    };
  },
  computed: {
    disableTwitter() {
      return process.env.VUE_APP_TWITTER_DISABLE=="true";
    },
  },
  mounted: async function() {
    await this.loadAuthUrl();

    Cookies.set("tw-return", this.$route.path, { expires: 365 });
  },
  methods: {
    loadAuthUrl: async function() {
      const response = await Back.requestTwitterAccessToken();
      if (response) {
        console.log("loadAuthUrl", response);
        this.authUrl = response.url;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.sign-in-to-twitter {
  background: #daedff;
  color: #2196f3;
}
</style>


